define.alias("shared/components/shared/post/secondary/activity/header", "settings/components/shared/post/secondary/activity/header");